import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import CollectPointsContent from "modules/CollectPoints";
import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const CollectPointsPage: React.FC = () => {
  setTitle("Collection Point");
  return (
    <Auth>
      <Layout>
        <CollectPointsContent />
      </Layout>
    </Auth>
  );
};

export default CollectPointsPage;
